import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc } from './format'

export function newEmployee(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_EMPLOYEE_START", payload: "" })
            console.log("new Employee START", {data})
            const res = await axios.post('/employees/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_EMPLOYEE_ERROR", dispatch) ){                
				dispatch({ type: "NEW_EMPLOYEE", payload: res.data })
				dispatch({ type: "CREATE_EMPLOYEE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new employee ", err);
            dispatch({
                type: "CREATE_EMPLOYEE_ERROR",
                payload: err
            })
        }
    }
}

export function fetchEmployees() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_EMPLOYEES_START", payload: "" })
            
            console.log("fetch Employee START")
            const res = await axios.get('/employees/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_EMPLOYEES_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_EMPLOYEES",
                    payload: formatList(orderByAsc(res.data, "employee_name"), "employee_id")
                })
                dispatch({ type: "FETCH_EMPLOYEES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get employees list ", err);
            dispatch({ type: "FETCH_EMPLOYEES_ERROR", payload: err })
        }
    }
}


export function updateEmployee(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_EMPLOYEE_START", payload: "" })
            
            console.log("update Employee START")
            const res = await axios.post("/employees/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_EMPLOYEE_ERROR", dispatch) ){  
                
				dispatch({
                    type: "UPDATE_EMPLOYEE",
                    payload: data
                })
				dispatch({ type: "UPDATE_EMPLOYEE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update employee ", err);
            dispatch({
                type: "UPDATE_EMPLOYEE_ERROR",
                payload: err
                
            })
        }
    }
}

export function newService(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SERVICE_START", payload: "" })
            console.log("new Service START", {data})
            const res = await axios.post('/employees/services/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_SERVICE_ERROR", dispatch) ){                
                dispatch({ type: "NEW_SERVICE", payload: res.data })
                dispatch({ type: "CREATE_SERVICE_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] new service ", err);
            dispatch({
                type: "CREATE_SERVICE_ERROR",
                payload: err
            })
        }
    }
}

export function fetchServices() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SERVICES_START", payload: "" })
            
            console.log("fetch Service START")
            const res = await axios.get('/employees/services/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SERVICES_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_SERVICES",
                    payload: formatList(orderByAsc(res.data, "service_name"), "service_id")
                })
                dispatch({ type: "FETCH_SERVICES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get services list ", err);
            dispatch({ type: "FETCH_SERVICES_ERROR", payload: err })
        }
    }
}
export function newFunction(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_FUNCTION_START", payload: "" })
            console.log("new Function START", {data})
            const res = await axios.post('/employees/functions/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_FUNCTION_ERROR", dispatch) ){                
                dispatch({ type: "NEW_FUNCTION", payload: res.data })
                dispatch({ type: "CREATE_FUNCTION_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] new function ", err);
            dispatch({
                type: "CREATE_FUNCTION_ERROR",
                payload: err
            })
        }
    }
}

export function fetchFunctions() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_FUNCTIONS_START", payload: "" })
            
            console.log("fetch Function START")
            const res = await axios.get('/employees/functions/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_FUNCTIONS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_FUNCTIONS",
                    payload: formatList(orderByAsc(res.data, "function_name"), "function_id")
                })
                dispatch({ type: "FETCH_FUNCTIONS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get functions list ", err);
            dispatch({ type: "FETCH_FUNCTIONS_ERROR", payload: err })
        }
    }
}